import './search-stats.html.twig';
import './search-stats.scss';
